import { Tab } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

export const DTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        minWidth: 72,
        minHeight: 'auto',
        padding: '5px 15px 5px 15px',
        fontWeight: "600",
        marginRight: theme.spacing(4),
        '&:hover': {
            color: '#40a9ff',
            opacity: 1,
        },
        '&$selected': {
            backgroundColor: '#434CE8',
            color: 'white',
            fontWeight: theme.typography.fontWeightMedium,
            borderRadius: '15px',
        },
        '&:focus': {
            color: 'white',
        },
        '& .MuiTab-wrapper': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            flexDirection: 'row',
        }
    },
    selected: {},
}))((props) => <Tab disableRipple {...props} />);